var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.config.placeholder,"format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","clearable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }